import request from "@/utils/request"

// 视频在线率统计（近1天/近7天/近30天 + 各通道明细）
export function VideoRateStats() {
  return request({
    url: "/admin/system/videoRate/findStats",
    method: "GET"
  })
}
